import * as Sentry from "@sentry/remix";
import { RemixBrowser } from "@remix-run/react";
import { startTransition, StrictMode, useEffect, useRef } from "react";
import { hydrateRoot } from "react-dom/client";

// Sentry Initialization
Sentry.init({
  dsn: "https://9e91dd2965de56d4bf196abc25b33086@o4505345949106176.ingest.us.sentry.io/4508731667775488",
});

// TypeScript declarations for GTM
declare global {
  interface Window {
    dataLayer: any[];
    gtag?: (...args: any[]) => void;
  }
}

// Client-only scripts
function ClientScripts() {
  const isInitialized = useRef(false);

  useEffect(() => {
    // Guard against double initialization
    if (isInitialized.current) {
      return;
    }
    isInitialized.current = true;

    // === Google Tag Manager ===
    if (!document.querySelector(`script[src*="googletagmanager.com/gtm.js"]`)) {
      (function (w: any, d: Document, s: string, l: string, i: string) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        const f = d.getElementsByTagName(s)[0];
        const j = d.createElement(s) as HTMLScriptElement;
        const dl = l !== "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode?.insertBefore(j, f);
      })(window, document, "script", "dataLayer", "GTM-TWHZWZCB");
    }

    // === Termly Script ===
    const termlySrc =
      "https://app.termly.io/resource-blocker/c95304e9-3d89-4e92-b961-4b4d7d694a07?autoBlock=off";
    const existingTermly = document.querySelector(`script[src="${termlySrc}"]`);
    if (!existingTermly) {
      const termlyScript = document.createElement("script");
      termlyScript.src = termlySrc;
      termlyScript.type = "text/javascript";
      termlyScript.async = true;
      document.body.appendChild(termlyScript);
    }
  }, []);

  return null;
}

// Hydrate the app
startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
      <ClientScripts />
    </StrictMode>,
  );
});
